/* ============================================================
   MC NAV — Shoes and Leather folded under Collections
   ------------------------------------------------------------
   Seven top-level entries, a booking pill, a search and a bag do
   not fit one row. Shoes and Leather are both collections, so
   they belong under Collections rather than beside it.

   The home page header is rendered by the compiled app bundle,
   which we do not own. Rather than move its nodes — React would
   fight us for them — we hide the two links with CSS and add our
   own panel as an extra child of <header>. If this script never
   runs, nothing is hidden and the original menu stands.

   The Liquid pages get the same structure from mc-header.liquid,
   in markup, with no JavaScript at all.
   ============================================================ */
(function () {
  'use strict';

  /* hash = une section de la page d'accueil ; path = une vraie page, prefixee
     par le marche courant pour ne pas declencher une redirection.
     Bespoke Tailoring vise l'ancre #lookbook, la grille des costumes, et non
     le haut de la page : la collection Shopify Suits & Tailoring est vide. */
  var ITEMS = [
    { label: 'Bespoke Tailoring', path: 'pages/bespoke-tailoring#lookbook' },
    { label: 'Shoes',             hash: '#shoes' },
    { label: 'Leather',           hash: '#leather' }
  ];

  var root = '/';
  try {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
  } catch (e) {}
  if (root.charAt(root.length - 1) !== '/') root += '/';

  var panel = null, anchor = null, hideTimer = null;

  var CSS = [
    /* The originals stay in React's tree, simply out of sight. */
    '#root header nav a[href="#shoes"],#root header nav a[href="#leather"]{display:none!important}',
    '.mcn-pan{position:absolute;top:100%;margin-top:2px;min-width:172px;padding:10px 0;',
      'background:rgba(7,17,31,.94);-webkit-backdrop-filter:blur(14px) saturate(150%);',
      'backdrop-filter:blur(14px) saturate(150%);border:1px solid rgba(255,255,255,.14);',
      'border-radius:14px;box-shadow:0 18px 40px rgba(0,0,0,.38);',
      'opacity:0;visibility:hidden;transform:translateY(-6px);',
      'transition:opacity .2s ease,transform .2s ease,visibility .2s;z-index:60}',
    '.mcn-pan.is-on{opacity:1;visibility:visible;transform:none}',
    '@media (prefers-reduced-motion:reduce){.mcn-pan{transition:none}}',
    '.mcn-pan a{display:block;padding:9px 20px;color:rgba(255,255,255,.78);text-decoration:none;',
      'font-size:13px;font-weight:500;letter-spacing:.02em;white-space:nowrap}',
    '.mcn-pan a:hover{color:#fff;background:rgba(255,255,255,.07)}',
    '.mcn-pan a:focus-visible{outline:2px solid #fff;outline-offset:-2px;border-radius:6px}',
    /* Drawn with a pseudo-element so React never sees a stray child node. */
    '#root header nav a[href="#collections"]::after{content:"";display:inline-block;width:6px;height:6px;',
      'margin-left:7px;vertical-align:2px;border-right:1.4px solid currentColor;',
      'border-bottom:1.4px solid currentColor;transform:rotate(45deg) translateY(-2px);opacity:.6}'
  ].join('');

  function injectCSS() {
    var s = document.createElement('style');
    s.id = 'mc-nav-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function findAnchor() {
    return document.querySelector('#root header nav a[href="#collections"]');
  }

  function build(header) {
    var p = document.createElement('div');
    p.className = 'mcn-pan';
    p.setAttribute('role', 'menu');
    p.innerHTML = ITEMS.map(function (it) {
      var href = it.hash ? it.hash : root + it.path;
      return '<a role="menuitem" href="' + href + '">' + it.label + '</a>';
    }).join('');

    header.appendChild(p);
    return p;
  }

  function overTrigger(el) {
    if (!el || !el.closest) return false;
    return !!(el.closest('#root header nav a[href="#collections"]') || el.closest('.mcn-pan'));
  }

  function position() {
    if (!panel || !anchor) return;
    var header = anchor.closest('header');
    if (!header) return;
    var a = anchor.getBoundingClientRect();
    var h = header.getBoundingClientRect();
    panel.style.left = Math.max(8, Math.round(a.left - h.left - 14)) + 'px';
  }

  function show() {
    if (!panel) return;
    clearTimeout(hideTimer);
    position();
    panel.classList.add('is-on');
    if (anchor) anchor.setAttribute('aria-expanded', 'true');
  }

  function hide() {
    if (!panel) return;
    panel.classList.remove('is-on');
    if (anchor) anchor.setAttribute('aria-expanded', 'false');
  }

  function leave() { clearTimeout(hideTimer); hideTimer = setTimeout(hide, 140); }

  /* The app re-renders its header, replacing the link node. Handlers bound to
     that node would receive a mouseleave on every swap and the panel would
     flicker, so hover is tracked at the document instead: the pointer's
     position is what matters, not which node currently represents the link. */
  function wire() {
    var a = findAnchor();
    if (!a) return false;

    var header = a.closest('header');
    if (!header) return false;

    if (!panel || !panel.isConnected) panel = build(header);

    if (a !== anchor) {
      anchor = a;
      anchor.setAttribute('aria-haspopup', 'true');
      anchor.setAttribute('aria-expanded', panel.classList.contains('is-on') ? 'true' : 'false');
    }
    position();
    return true;
  }

  function start() {
    if (!document.getElementById('root')) return;   /* Liquid pages do it in markup */
    injectCSS();

    document.addEventListener('pointerover', function (e) {
      if (!panel) return;
      if (overTrigger(e.target)) { clearTimeout(hideTimer); show(); }
      else leave();
    }, true);

    document.addEventListener('click', function (e) {
      if (overTrigger(e.target)) hide();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });

    document.addEventListener('focusin', function (e) {
      if (!panel) return;
      if (overTrigger(e.target)) show();
      else if (panel.classList.contains('is-on')) hide();
    });
    window.addEventListener('resize', position, { passive: true });

    wire();

    try {
      var queued = false;
      var mo = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; wire(); });
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}

    /* The header only exists once the app has mounted; the observer takes
       over for every re-render after that. */
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (wire() || tries > 40) clearInterval(t);
    }, 250);
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
